import useAxios from '@/hooks/useAxios.hook';
import { setLoginPopup } from '@/redux/actions/common.action';
import { setUserData } from '@/redux/actions/user.action';
import { AppDispatch } from '@/redux/store';
import { endPoint, setCookie } from '@/utils';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';

const useOtpVerify = ({ state, onNext, onSuccess }: any) => {
  const dispatch = useDispatch<AppDispatch>();

  const initialValues = { code: '' };
  const otpValidationSchema = yup.object().shape({
    code: yup
      .string()
      .required('OTP is required')
      .matches(/^[0-9]+$/, 'OTP is not valid')
      .min(6, 'OTP is not valid')
      .max(6, 'OTP is not valid'),
  });
  const { fetchData, loading } = useAxios();
  const handleSubmit = async (
    values: any,
    { setSubmitting, setErrors }: any,
  ) => {
    const data = {
      otp: values.code,
      otpId: state?.otpId,
      role: state?.role,
    };

    const res: any = await fetchData({
      url: endPoint.VALIDATE_LOGIN_OTP,
      method: 'POST',
      data,
    });
    if (res?.data?._id && res?.data?.accessToken) {
      setCookie('token', res?.data?.accessToken, 365);
      if (res?.data?.profileComplete) {        
        dispatch(setUserData(res?.data));
        dispatch(setLoginPopup(false));
        if (onSuccess) onSuccess?.();
      } else {
        onNext();
      }
    } else {
      setSubmitting(false);
      setErrors({ code: res?.message });
    }
  };
  return {
    initialValues,
    otpValidationSchema,
    handleSubmit,
    loading,
  };
};

export default useOtpVerify;
